import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Clipboard16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M11.5 7.75H7V6.25H11.5V7.75Z' fill='currentColor' />
    <path d='M7 11.25H11.5V9.75H7V11.25Z' fill='currentColor' />
    <path
      d='M6 7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6C5.55228 6 6 6.44772 6 7Z'
      fill='currentColor'
    />
    <path
      d='M5 11.5C5.55228 11.5 6 11.0523 6 10.5C6 9.94771 5.55228 9.5 5 9.5C4.44772 9.5 4 9.94771 4 10.5C4 11.0523 4.44772 11.5 5 11.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.225 1.25H13.5C14.1904 1.25 14.75 1.80964 14.75 2.5V14C14.75 14.6904 14.1904 15.25 13.5 15.25H2.5C1.80964 15.25 1.25 14.6904 1.25 14V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H4.775C4.89082 0.67944 5.39526 0.25 6 0.25H10C10.6047 0.25 11.1092 0.67944 11.225 1.25ZM4.75 2.75H2.75V13.75H13.25V2.75H11.25V3C11.25 3.69036 10.6904 4.25 10 4.25H6C5.30964 4.25 4.75 3.69036 4.75 3V2.75ZM6.25 2.75V1.75H9.75V2.75H6.25Z'
      fill='currentColor'
    />
  </Svg>
);

Clipboard16.displayName = 'Clipboard16';
export default Clipboard16;
